import styled from 'styled-components';

export const HeroContainer = styled.section`
  padding: 4rem 0 1rem;
  text-align: center;
  max-width: 900px;
  margin: auto;

  @media screen and (min-width: 1024px) {
    padding: 6rem 0 1rem;
  }
`;
